// TintiCloud — WordPress & Import. Dados de demonstração.
export const wordpressSites = [
  { id: "wp1", name: "Smartfolks", domain: "smartfolks.com.br", server: "sv2", version: "6.7", php: "8.2", status: "healthy", updates: 0, plugins: 14, ssl: "valid", backup: "há 6h" },
  { id: "wp2", name: "TintiTech Blog", domain: "blog.tintitech.com.br", server: "sv2", version: "6.6", php: "8.1", status: "warning", updates: 3, plugins: 22, ssl: "valid", backup: "há 1d" },
  { id: "wp3", name: "C2Desk Institucional", domain: "site.c2desk.com.br", server: "sv1", version: "6.7", php: "8.2", status: "healthy", updates: 1, plugins: 9, ssl: "valid", backup: "há 12h" },
];

export const importMethods = [
  { key: "wordpress", title: "WordPress", desc: "Migração automática de site WordPress existente", icon: "wordpress" },
  { key: "ssh", title: "SSH / SFTP", desc: "Importar arquivos e banco via acesso SSH/SFTP", icon: "terminal" },
  { key: "cpanel", title: "cPanel", desc: "Importar diretamente de uma conta cPanel", icon: "server" },
  { key: "backup", title: "Backup", desc: "Restaurar a partir de um arquivo de backup", icon: "archive" },
  { key: "manual", title: "Manual", desc: "Configurar tudo manualmente, passo a passo", icon: "settings" },
];
